"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSelectorInfoMap = createSelectorInfoMap;
function createSelectorInfoMap(selectors) {
    return selectors.reduce((soFar, selectorInfo) => {
        soFar[selectorInfo.propertyName] = selectorInfo;
        return soFar;
    }, {});
}
//# sourceMappingURL=selector-info-map.js.map